import O1HD from "../../../../../engines/gameEngine";
const {ccclass, property} = cc._decorator;

/**
 * 图鉴
 */
@ccclass
export default class DrawingGuideNode extends cc.Component {

    @property(cc.PageView)
    pageView : cc.PageView = null;
    @property(cc.Node)
    btnChicken : cc.Node = null;
    @property(cc.Node)
    btnEgg : cc.Node = null;

    onLoad () {}

    start () {

    }

    /**
     * 选择
     * @param e
     * @param define
     */
    onBtnSelectPage( e , define ){
        switch ( define ) {
            case "0":
                this.btnChicken.getChildByName("chooseBg").active = true;
                this.btnEgg.getChildByName("chooseBg").active = false;
                this.pageView.setCurrentPageIndex(0);
                break;
            case "1":
                this.btnChicken.getChildByName("chooseBg").active = false;
                this.btnEgg.getChildByName("chooseBg").active = true;
                this.pageView.setCurrentPageIndex(1);
                break;
            case "2":
                O1HD.getModules().uiControlModule.showMessageBox("暂未开放");
                break;
        }
    }

    /**
     * 关闭
     */
    onBtnClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.node.removeFromParent();
        this.node.destroy();
    }

}
